import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Spin, Empty } from "antd";
import { Link, useNavigate } from "react-router-dom";
import {
  AppstoreOutlined,
  CustomerServiceOutlined,
  RocketOutlined,
  TeamOutlined,
  PictureOutlined,
  HeartOutlined,
  TrophyOutlined,
  ReadOutlined,
  GlobalOutlined,
  CoffeeOutlined,
} from "@ant-design/icons";

import { 
  selectEventCategories, 
  selectFetchCategoriesLoading, 
  selectFetchCategoriesError,
  fetchEventCategories
} from "../../redux/eventSlice";

export default function EventCategoriesSection() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // Event Categories State
  const eventCategories = useSelector(selectEventCategories);
  const eventCategoriesLoading = useSelector(selectFetchCategoriesLoading);
  const eventCategoriesError = useSelector(selectFetchCategoriesError);

  // Fetch event categories on component mount
  useEffect(() => {
    dispatch(fetchEventCategories());
  }, [dispatch]);

  const getCategoryIcon = (categoryName = "") => {
    const key = categoryName.toLowerCase();
    if (key.includes("music")) return <CustomerServiceOutlined />;
    if (key.includes("tech") || key.includes("science")) return <RocketOutlined />;
    if (key.includes("business")) return <AppstoreOutlined />;
    if (key.includes("food") || key.includes("drink")) return <CoffeeOutlined />;
    if (key.includes("community")) return <TeamOutlined />;
    if (key.includes("art")) return <PictureOutlined />;
    if (key.includes("health")) return <HeartOutlined />;
    if (key.includes("sport")) return <TrophyOutlined />;
    if (key.includes("education")) return <ReadOutlined />;
    if (key.includes("travel")) return <GlobalOutlined />;
    return <AppstoreOutlined />;
  };

  return (
    <section className="homeV2Section eventCategoriesSection" id="categories">
      <div className="container">
        <div className="homeV2SectionHeader">
          <h2 className="homeV2SectionTitle">Explore By Category</h2>
          <Link className="homeV2ViewLink" to="/discover-events">
            View All
          </Link>
        </div>
        <Spin spinning={eventCategoriesLoading} tip="Loading event categories...">
          {eventCategories && eventCategories?.length > 0 && !eventCategoriesError ? (
            <div className="eventCategoriesRow">
              {eventCategories?.slice(0, 8).map((item) => (
                <button
                  type="button"
                  key={item.id}
                  className="eventCategoryCard"
                  onClick={() => item.slug && navigate(`/events/category/${item.slug}`)}
                  disabled={!item.slug}
                >
                  <div className="eventCategoryCardIconArea">
                    <span className="eventCategoryCardIcon">{getCategoryIcon(item.name)}</span>
                  </div>
                  <div className="eventCategoryCardBody">
                    <h3 className="eventCategoryCardTitle">{item.name}</h3>
                    <p className="eventCategoryCardMeta">Upcoming events</p>
                  </div>
                </button>
              ))}
            </div>
          ) : (
            <Empty description="No event categories found" />
          )}
        </Spin>
      </div>
    </section>
  );
}